/**
 * Make key name safe to save as a file
 */
export function escapeNamedValueKey(keyName: string): string {
    const camel = keyName.replace('/', '__');
    let snake = '';

    // convert camel-case to snake-case
    for (let i = 0; i < camel.length; i++) {
        if (i !== 0 && /[A-Z]/.test(camel[i])) {
            snake += '_' + camel[i].toLowerCase();
        } else {
            snake += camel[i].toLowerCase();
        }
    }

    return snake;
}
